<script lang="ts">
	import { spellSchools } from "../data/spells";
	import {
		Character,
		characterStore,
		initCharacter,
	} from "../character/character";

	let character: Character = initCharacter();

	characterStore.subscribe((chara) => {
		character = chara
	});
</script>

<h2>Spruchliste</h2>

<div
	class="
		grid
		grid-cols-1 gap-4
		sm:grid-cols-2
		lg:grid-cols-3
		xl:grid-cols-4
		2xl:grid-cols-5
	"
>
	{#each spellSchools as spellschool}
		<div class="border border-gray-300 rounded-md bg-gray-100 p-2">
			<h3>{spellschool.name}</h3>

			<ul>
				{#each spellschool.spellLists as spelllist}
					<li>
						{#if character.spellLists.find((n) => n.id == spelllist.id) == undefined}
							{spelllist.name}

							<button
								on:click={() => {
									character.spellLists.push({ ...spelllist });
									characterStore.set(character);
								}}
							>
								+
							</button>
						{:else}
							<strong>
								{spelllist.name}
							</strong>
						{/if}
					</li>
				{/each}
			</ul>
		</div>
	{/each}
</div>
